import React from 'react';

import { Clock, Diploma, Laptop } from '@crehana/icons';

import { useTranslation } from '@crehana/i18n';

import { useCheckoutContext } from 'Jsx/CheckoutV4/Context';

const DegreeBenefits = () => {
  const { t } = useTranslation();
  const { isBootcamp } = useCheckoutContext();

  return (
    <ul>
      <li className="flex items-center mb-24">
        <div>
          <Diploma size={17} className="mr-8" />
        </div>
        <p className="font-body3">{t('DEGREE_BENEFIT_1')}</p>
      </li>
      <li className="flex items-center mb-24">
        <Clock size={17} className="mr-8" />
        <p className="font-body3">
          {isBootcamp ? t('BOOTCAMP_BENEFIT_2') : t('DEGREE_BENEFIT_2')}
        </p>
      </li>
      <li className="flex items-center">
        <Laptop size={17} className="mr-8" />
        <p className="font-body3">{t('DEGREE_BENEFIT_3')}</p>
      </li>
    </ul>
  );
};

export default DegreeBenefits;
